import { render } from "./ClientsMonthlyDetail.vue?vue&type=template&id=7eadf54a&scoped=true"
import script from "./ClientsMonthlyDetail.vue?vue&type=script&lang=js"
export * from "./ClientsMonthlyDetail.vue?vue&type=script&lang=js"

import "./ClientsMonthlyDetail.vue?vue&type=style&index=0&id=7eadf54a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eadf54a"]])

export default __exports__